import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-catalog-delete-confirm-modal',
  templateUrl: './catalog-delete-confirm-modal.html',
})
export class CatalogDeleteConfirmModalComponent {
  @Input({ required: true })
  modalId = '';

  @Input({ required: true })
  title = '';

  @Input({ required: true })
  message = '';

  @Input({ required: true })
  confirmLabel = '';

  @Input()
  confirming = false;

  @Output()
  confirm = new EventEmitter<void>();

  @Output()
  cancel = new EventEmitter<void>();
}
